import {
  ErrorBoundary,
  AuthProvider,
  setBaseUrl,
  ConfigProvider,
  UiConfigProvider,
  TranslateProvider,
} from 'library';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL as string;
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppRoutes from './routes/AppRoutes';
import { models } from './config/models';
import { oauth2Config } from './config/auth';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});

function App() {
  setBaseUrl(API_BASE_URL);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <UiConfigProvider>
          <AuthProvider models={models} oauth2Config={oauth2Config}>
            <TranslateProvider>
              <ConfigProvider>
                <AppRoutes />
              </ConfigProvider>
            </TranslateProvider>
          </AuthProvider>
        </UiConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
